import React from 'react'
import { ContentBlock } from 'components/ContentBlock'
import styled from 'styled-components'
import get from 'lodash/get'

export const Wrapper = styled.div`
	width: 100%;
	height: 100vh;
	padding-top: ${({ theme }) => get(theme, 'navBarHeight.mainSections', '0px')};
	padding-bottom: ${({ theme }) => get(theme, 'navBarHeight.bottomNav', '0px')};
`
export const Content = styled.div(({ theme }) => `
	max-width: ${theme.contentMaxWidth};
	height: 100%;
	display: flex;
	margin-left: auto;
	margin-right: auto;
	padding: 15px 20px 20px;
	background: #f8fdff;
`)


const InitLoading = () => (
	<Wrapper>
		<Content>
			<ContentBlock isLoading={true} />
		</Content>
	</Wrapper>
)

export default InitLoading
